import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import { Text } from 'recharts';

const styles = () => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    flexGrow: 1,
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  pagerTitle: {
    padding: '20px 10px 10px'
  },
  paper: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleGroup: {
    marginTop: 10
  },
  pagerInDiv: {
    paddingLeft: 20,
    paddingRight: 20
  },
  pagerActions: {
    padding: '15px 10px',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  bold: {
    fontWeight: 'bold'
  },
  font20: {
    fontSize: 20
  },
  font16: {
    fontSize: 16
  },
  font14: {
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  btnBack: {
    marginRight: 10
  },
  ml10: {
    marginLeft: 10
  },
  labelRadio: {
    fontSize: 14
  },
  ulWrap: {
    paddingLeft: 20,
    margin: 0
  },
  divider: {
    marginTop: 20
  }
});

const enhance = compose();

const Main = enhance(({ classes, setOpenHelpModal }) => {
  return (
    <Container component="main" className={classes.main}>
      <CssBaseline />
      <div className={classes.page}>
        <Paper className={classes.paper} elevation={1}>
          <div className={classes.pagerTitle}>
            <Text className={[classes.font20, classes.bold]}>
              メニュー作り方の例
            </Text>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                お店の看板メニュー・人気メニュー
              </Typography>
            </div>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                社食サービス「社食ごちめし」向きのメニュー
              </Typography>
            </div>
            <div className={classes.descriptionGroup}>
              <ul className={classes.ulWrap}>
                <li>
                  <Typography className={classes.font12}>
                    ランチ向き価格500円～1500円くらい
                  </Typography>
                </li>
                <li>
                  <Typography className={classes.font12}>
                    定食・ワンプレートなど
                  </Typography>
                </li>
                <li>
                  <Typography className={classes.font12}>
                    お弁当メニューなど
                  </Typography>
                </li>
              </ul>
            </div>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                ドリンクメニュー
              </Typography>
            </div>
            <div className={classes.descriptionGroup}>
              <ul className={classes.ulWrap}>
                <li>
                  <Typography className={classes.font12}>
                    同じ価格のものは「ソフトドリンク」でなどまとめて登録もOK
                  </Typography>
                </li>
              </ul>
            </div>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                サイドメニュー
              </Typography>
            </div>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                コースメニュー
              </Typography>
            </div>
            <div className={classes.descriptionGroup}>
              <ul className={classes.ulWrap}>
                <li>
                  <Typography className={classes.font12}>
                    予約の必要や人数制限など、条件についてはメニュー説明欄に記載してください。
                  </Typography>
                </li>
              </ul>
            </div>
          </div>
          <div className={classes.pagerInDiv}>
            <div className={classes.titleGroup}>
              <Typography className={[classes.font14, classes.bold]}>
                回数券を作成
              </Typography>
            </div>
            <div className={classes.descriptionGroup}>
              <ul className={classes.ulWrap}>
                <li>
                  <Typography className={classes.font12}>
                    無料分やおまけ付きでお得に販売できる回数券メニューも作成できます。
                  </Typography>
                </li>
              </ul>
            </div>
          </div>
          <Divider className={classes.divider} />
          <div className={classes.pagerActions}>
            <div className={classes.btnBack}>
              <Button
                variant="text"
                color="primary"
                onClick={() => setOpenHelpModal(false)}
              >
                <Text className={classes.bold}>閉じる</Text>
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    </Container>
  );
});

export default withRouter(withStyles(styles)(Main));
